export const buildLineChartjsStackedOptionsProp = () => {
  return {
    plugins: {
      legend: {
        display: true,
        position: 'bottom'
      }
    },
    scales: {
      y: {
        ticks: {
          callback: (value, _index, _ticks) => {
            return value
          }
        }
      }
    }
  }
}
